import moment from 'moment';

/**
 * Formats a datetime string for display in the user's local timezone.
 * Input is expected to be a UTC datetime string (timezone-naive values are assumed UTC).
 */
export function formatDateTime(value: string | null | undefined, format = 'MMM D, YYYY'): string {
    if (!value) {
        return '';
    }
    return moment.utc(value).local().format(format);
}
